import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export async function GetVerifyTokenOnboarding(params) {
  const res = await api.get(routes.VERIFY_TOKEN_ONBOARDING, {
    params: params,
  });
  return res;
}

export async function PostSetPassword(formData, token) {
  let jsonData = Object.fromEntries(formData.entries());

  jsonData = {
    ...jsonData,
    token: token,
  };

  const res = await api.post(routes.TOKEN_SET_PASSWORD, jsonData);
  return res;
}
